import React from 'react'
import {Button} from "antd";
import {Link} from "react-router-dom";

const AppButton=({
                     success,
    glow,
    stylized,
    onClick,
    to,
                     ...props})=>{

    var button = () => <><Button className={[success && 'success-bg',glow && 'glow']} {...props}
                         onClick={onClick}
    >
        {
            props.children
        }

    </Button>
    {
        stylized && <div className={'stylized-button'}
                         onClick={onClick}
        >
        </div>
    }
    <Button className={'absolute-centered transparent'}
            {...props}
    >
        <>
            {
                props.children
            }
        </>
    </Button>
    </>

    return(
    <div style={{position:'relative'}}>
        {
            to?
                <Link to={to}>
                    {button()}
                </Link>
                :
                button()
        }

    </div>
    )
}



export default AppButton